module.exports = __webpack_public_path__ + "img/制御工学8_1.7fd068e8.png";